import { createSlice } from '@reduxjs/toolkit'

const initialStateValue = {
permissions:null
}

export const permissions = createSlice({
  name: 'permissions',
  initialState: initialStateValue,
  reducers: {
    setPermissions:(state,action)=>{
      state.permissions = action.payload
    },
  },
})

export const { setPermissions} = permissions.actions

export default permissions.reducer
